import * as r from "@sentry/react";
const d = ({
  tenantId: t,
  brand: e,
  dsn: n,
  router: o,
  tracePropagationTargets: i = ["localhost", /^https:\/\/elantil.sentry\.io\/api/],
  tracesSampleRate: a = 1,
  replaysSessionSampleRate: s = 0.1,
  replaysOnErrorSampleRate: c = 1
}) => {
  if (!n) {
    console.log("Sentry logging is disabled. No DSN provided.");
    return;
  }
  try {
    r.init({
      dsn: n,
      integrations: [
        r.browserTracingIntegration(),
        r.tanstackRouterBrowserTracingIntegration(o),
        r.replayIntegration()
      ],
      tracesSampleRate: a,
      tracePropagationTargets: i,
      replaysSessionSampleRate: s,
      replaysOnErrorSampleRate: c
    }), g({
      tenant_id: t,
      brand: e
    });
  } catch (l) {
    console.error("Failed to initialize Sentry:", l);
  }
}, g = (t) => {
  Object.keys(t).forEach((e) => {
    r.setTag(e, t[e]);
  });
}, y = (t) => {
  t.forEach((e) => {
    r.setTag(e, void 0);
  });
}, S = r.reactErrorHandler;
export {
  g as addSentryTags,
  d as initializeSentry,
  y as removeSentryTags,
  S as sentryErrorHandler
};
